// extracted by mini-css-extract-plugin
export var emailBlockLink = "_p6-0";